export default {
  badge: 'Insignă',
  open: 'Open',
  close: 'Închideți',
  dismiss: 'Dismiss',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Anulează',
  },
  dataIterator: {
    noResultsText: 'Nu s-au găsit înregistrări corespunzătoare',
    loadingText: 'Se încarcă articolele...',
  },
  dataTable: {
    itemsPerPageText: 'Rânduri pe pagină:',
    ariaLabel: {
      sortDescending: 'Sortate descendent.',
      sortAscending: 'Sortate ascendent.',
      sortNone: 'Nesortate.',
      activateNone: 'Activați pentru a elimina sortarea.',
      activateDescending: 'Activați pentru a sorta descendent.',
      activateAscending: 'Activați pentru a sorta ascendent.',
    },
    sortBy: 'Sortați după',
  },
  dataFooter: {
    itemsPerPageText: 'Articole pe pagină:',
    itemsPerPageAll: 'Toate',
    nextPage: 'Pagina următoare',
    prevPage: 'Pagina anterioară',
    firstPage: 'Prima pagină',
    lastPage: 'Ultima pagină',
    pageText: '{0}-{1} din {2}',
  },
  dateRangeInput: {
    divider: 'până la',
  },
  datePicker: {
    itemsSelected: '{0} selected',
    range: {
      title: 'Selectați datele',
      header: 'Introduceți datele',
    },
    title: 'Selectați data',
    header: 'Introduceți data',
    input: {
      placeholder: 'Introduceți data',
    },
  },
  noDataText: 'Nu există date disponibile',
  carousel: {
    prev: 'Vizualul anterior',
    next: 'Vizualul următor',
    ariaLabel: {
      delimiter: 'Slide carusel {0} din {1}',
    },
  },
  calendar: {
    moreEvents: 'încă {0}',
    today: 'Today',
  },
  input: {
    clear: 'Șterge {0}',
    prependAction: '{0} acțiune de inserare la început',
    appendAction: '{0} acțiune de inserare la sfârșit',
    otp: 'Please enter OTP character {0}',
  },
  fileInput: {
    counter: '{0} fișiere',
    counterSize: '{0} fișiere ({1} în total)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Select Time',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigare prin pagini',
      next: 'Pagina următoare',
      previous: 'Pagina anterioară',
      page: 'Mergeți la pagina {0}',
      currentPage: 'Pagina curentă, pagina {0}',
      first: 'Prima pagină',
      last: 'Ultima pagină',
    },
  },
  stepper: {
    next: 'Next',
    prev: 'Previous',
  },
  rating: {
    ariaLabel: {
      item: 'Rating de {0} din {1}',
    },
  },
  loading: 'Se încarcă...',
  infiniteScroll: {
    loadMore: 'Încarcă mai multe',
    empty: 'Nu mai există',
  },
}
